export function addFooter(pdf, payload) {
  const totalPages = pdf.internal.getNumberOfPages();
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);

    pdf.setFontSize(8);
    pdf.setTextColor(0);
    pdf.text(
      `${payload.school.name} SRL, ${payload.school.sede_legale} - Tel. +39 ${payload.school.telefono} P.IVA: ${payload.school.piva}`,
      pdfWidth / 2,
      pdfHeight - 18,
      { align: 'center' }
    );

    pdf.text(
      `Sito web: ${payload.school.url}`,
      pdfWidth / 2,
      pdfHeight - 14,
      { align: 'center' }
    );

    pdf.setTextColor(120);
    pdf.text(
      `Pagina ${i} di ${totalPages}`,
      pdfWidth / 2,
      pdfHeight - 8,
      { align: 'center' }
    );
  }
}
